var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showDialog
    ? _c(_setup.PromptDialogComponent, {
        attrs: {
          title: _setup.text.title,
          isOpened: _vm.showDialog,
          context: "statusForm",
          formSchema: _setup.parsedFormSchema,
          formFieldValues: _setup.formData,
          width: _setup.modalWidth,
        },
        on: { "execute-action": _setup.onExecuteAction },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }